/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { format } from "date-fns";
import Layout from "../../layout/Main/Layout";
import CustomTable from "../../components/Custom/Table/CustomTable";
import { get, put, post, postFiles, patch } from "../../config/axios";
import {  Box,
  Modal,
  Typography,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  CircularProgress, 
  DialogTitle,
  Divider,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Chip,
  FormControl,
  InputLabel,
  Select,
  MenuItem} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Searchbar from "../../components/Custom/SearchBar/Searchbar";
import DeleteModal from "../../components/Custom/DeleteModal/DeleteModal";
import { deleteAPI } from "../../helper/apiCallHelper";
import { useDebouncedValue } from "../../helper/debounce";
import { toastMessage } from "../../utils/toastMessage";
import FormModal from "../../components/Custom/FormModal/FormModal";
// import { dietTableColumns } from "../../constants/DietPage";
import { DietMealPlanTableColumns } from "../../constants/DietMealPlan";
import styles from "./DietMealPlan.module.css";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import {
  IconButton,
} from "@mui/material"
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import { EditableMealPlanTable } from "./EditableMealPlanTable";
const DietMealPlan = () => {
  const [users, setUsers] = useState([]);
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteUser, setDeleteUser] = useState("");
  const [search, setSearch] = useState("");
  const [message, setMessage] = useState("");
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [totalData, setTotalData] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [generatingPlan, setGeneratingPlan] = useState({}); // Track which plan is being generated
  const debouncedSearch = useDebouncedValue(search, 500);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [selectedCategory, setSelectedCategory] = useState("");
  const [uploadLoading, setUploadLoading] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [viewData, setViewData] = useState({});
  const [previewModal, setPreviewModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [mealPlans, setMealPlans] = useState([]);
  const [patients, setPatients] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedMealPlan, setSelectedMealPlan] = useState("");
  const [viewModalOpen, setViewModalOpen] = useState(false);
  
  // Diet type filtering
  const [dietTypeFilter, setDietTypeFilter] = useState("all");
  const [phaseFilter, setPhaseFilter] = useState("all");
  const [weekFilter, setWeekFilter] = useState("all");
  
  // Diet type options
  const dietTypeOptions = [
    { value: "all", label: "All Diet Types" },
    { value: "traditional", label: "Traditional" },
    { value: "low_fodmap", label: "Low FODMAP" }
  ];
  
  // Phase options for Low FODMAP
  const phaseOptions = [
    { value: "all", label: "All Phases" },
    { value: "elimination", label: "Elimination" },
    { value: "introduction", label: "Introduction" },
    { value: "maintenance", label: "Maintenance" }
  ];
  
  // Handle diet type filter change
  const handleDietTypeFilterChange = (event) => {
    setDietTypeFilter(event.target.value);
    setPage(1); // Reset to first page when filter changes
  };
  
  // Handle phase filter change
  const handlePhaseFilterChange = (event) => {
    setPhaseFilter(event.target.value);
    setPage(1); // Reset to first page when filter changes
  };

  // Handle week filter change
  const handleWeekFilterChange = (event) => {
    setWeekFilter(event.target.value);
    setPage(1); // Reset to first page when filter changes
  };
  
  // Get filtered meal plans based on current filters
  const getFilteredMealPlans = () => {
    let filtered = mealPlans;
    
    // Filter by diet type
    if (dietTypeFilter !== "all") {
      filtered = filtered.filter(plan => plan.dietType === dietTypeFilter);
      console.log(`Filtered by diet type ${dietTypeFilter}:`, filtered.length, 'plans');
    }
    
    // Filter by phase (only for Low FODMAP diets)
    if (phaseFilter !== "all" && dietTypeFilter === "low_fodmap") {
      filtered = filtered.filter(plan => {
        const phase = plan.dietInfo?.phase || plan.dietInfo?.lowFodmap?.currentPhase;
        return phase === phaseFilter;
      });
      console.log(`Filtered by phase ${phaseFilter}:`, filtered.length, 'plans');
    }

    // Filter by current week
    if (weekFilter !== "all") {
      filtered = filtered.filter(plan => {
        const currentWeek = plan.dietInfo?.currentWeek || plan.dietInfo?.lowFodmap?.currentWeek;
        return currentWeek === parseInt(weekFilter);
      });
      console.log(`Filtered by week ${weekFilter}:`, filtered.length, 'plans');
    }
    
    console.log('Total filtered plans:', filtered.length);
    return filtered;
  };
  
  // Get display text for diet type
  const getDietTypeDisplay = (dietType) => {
    switch (dietType) {
      case "traditional":
        return { label: "Traditional", color: "primary" };
      case "low_fodmap":
        return { label: "Low FODMAP", color: "secondary" };
      default:
        return { label: "Unknown", color: "default" };
    }
  };
  
  // Get display text for phase
  const getPhaseDisplay = (plan) => {
    if (plan.dietType !== "low_fodmap") {
      return { label: "N/A", color: "default" };
    }
    
    const phase = plan.dietInfo?.phase || plan.dietInfo?.lowFodmap?.currentPhase;
    switch (phase) {
      case "elimination":
        return { label: "Elimination", color: "error" };
      case "introduction":
        return { label: "Introduction", color: "warning" };
      case "maintenance":
        return { label: "Maintenance", color: "success" };
      default:
        return { label: "Unknown", color: "default" };
    }
  };
  
  // Reset all filters
  const resetFilters = () => {
    setDietTypeFilter("all");
    setPhaseFilter("all");
    setWeekFilter("all");
    setPage(1);
  };
  const [blogContentFormFields, setBlogContentFormFields] = useState([
    { name: "title", label: "Title", type: "text", required: true },
    {
      name: "category",
      label: "Category",
      type: "category",
      isMultiSelect: false,
      options: [],
      required: true,
    },
    {
      name: "subCategory",
      label: "SubCategory",
      type: "subCategory",
      isMultiSelect: false,
      options: [],
      required: true,
    },

    {
      name: "languages",
      label: "Language",
      type: "option",
      options: ["ENGLISH", "HINDI"],
      required: true,
    },

    {
      name: "assets",
      label: "Attachment",
      type: "file",
      required: false,
    },
    {
      name: "thumbnail",
      label: "Thumbnail",
      type: "file",
      required: false,
    },
  ]);

//   const fetchUsers = async (searchValue) => {
//     try {
//       setLoading(true);
//       const res = await get(
//         `http://localhost:10007/api/app/diet/mealPlanGetAdmin?page=${page}&limit=${10}&search=${searchValue}&type=DIET_VIDEOS`
//       );
//       const response = await get(
//         `api/dashboard/apputility/getCategory?type=DIET_VIDEOS&totalData=true`
//       );
//       setBlogContentFormFields((prev) =>
//         prev.map((field) => {
//           if (field.name === "category") {
//             return { ...field, options: response?.data };
//           }
//           return field;
//         })
//       );
//       setUsers(
//         res?.data.map((item) => {
//           console.log(item);
//           return {
//             ...item,
//             action: { edit: true, delete: true },
//             categoryTitle: item.category ? item.category.title : "",
//             subCategoryTitle: item.subCategory ? item.subCategory.title : "",
//           };
//         })
//       );
//     //   fetchSubCategories();
//       setLoading(false);
//       setPageCount(res?.totalPage);
//       setTotalData(res?.totalData);
//       setPerPage(res?.perPage);
//       setCurrentPage(res?.currentPage);
//     } catch (err) {
//       console.error("Error:", err);
//       setLoading(true);
//     }
//   };
console.log("meal",mealPlans)
const fetchMealPlans = async (searchValue) => {
    try {
      setLoading(true);
  
      const response = await get(
        `/api/dashboard/diet/mealPlanGetAdmin?page=${page}&limit=${perPage}&search=${searchValue || ""}`
      );
      console.log("-------> API Response:", response); // Log the entire response for debugging
  
      // Check if response is an error object
      if (response && response.errorType) {
        console.error("API Error:", response);
        toastMessage(response.message || "Failed to fetch meal plans", "error");
        setMealPlans([]); // Set empty array instead of error object
        setLoading(false);
        return;
      }
  
      // Accessing data from the response object
      const { data: mealPlans, total, totalPages } = response; // Correct access from response.data

      if (!mealPlans) {
        console.error("Missing mealPlans data:", response);
        setMealPlans([]); // Set empty array instead of undefined
        setLoading(false);
        return;
      }
  
      const enrichedPlans = mealPlans.map((plan, index) => {
        // Log a sample plan for debugging
        if (index === 0) {
          console.log("🔍 [DietMealPlan] Sample raw plan from API:", plan);
          console.log("🔍 [DietMealPlan] Sample plan keys:", Object.keys(plan || {}));
        }

        // Backend guarantees these now:
        // - plan.patientId (string)
        // - plan.userId (string)
        // - plan.patient object with at least _id
        const patientId =
          plan.patientId ||
          plan.userId ||
          plan.patient?._id ||
          null;

        const patientName =
          plan.patient?.fullname ||
          plan.patient?.name ||
          (patientId ? `Patient ID: ${patientId}` : "Unknown Patient");

        return {
          ...plan,
          SNo: (page - 1) * 10 + index + 1,
          action: {
            edit: true,
            delete: true,
            // Generate is allowed whenever we have a patientId/userId as per backend contract
            generate: !!patientId,
          },
          // Normalized patient fields used by the table
          patientName,
          patient: plan.patient,
          patientId,
          // Existing diet info mappings
          dietType: plan.dietType || "unknown",
          phase:
            plan.dietInfo?.phase ||
            plan.dietInfo?.lowFodmap?.currentPhase ||
            "N/A",
          currentWeek:
            plan.dietInfo?.currentWeek ||
            plan.dietInfo?.lowFodmap?.currentWeek ||
            "N/A",
          createdAt: format(new Date(plan.createdAt), "dd MMM yyyy"),
          updatedAt: format(new Date(plan.updatedAt), "dd MMM yyyy"),
        };
      });
  
      setMealPlans(enrichedPlans);
      setPageCount(totalPages);
      setTotalData(total);
      setPerPage(10);
      setCurrentPage(page);
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch meal plans:", error);
      setMealPlans([]); // Set empty array instead of error object
      setLoading(false);
    }
  };
  

//   const fetchSubCategories = async () => {
//     const res = await get(
//       `/api/dashboard/apputility/getSubCategory?category=${selectedCategory}`
//     );
//     setBlogContentFormFields((prev) =>
//       prev.map((field) => {
//         if (field.name === "subCategory") {
//           return { ...field, options: res?.data };
//         }
//         return field;
//       })
//     );
//   };
//   useEffect(() => {
//     fetchSubCategories();
//   }, [selectedCategory]);

useEffect(() => {
    // Only call fetchMealPlans when debouncedSearch or page changes
    if (debouncedSearch !== "") {
      fetchMealPlans(debouncedSearch);
      // Reset filters when search changes
      resetFilters();
    } else {
      fetchMealPlans("");  // If the search is empty, fetch with an empty string
    }
  }, [debouncedSearch, page]);

  const handleEdit = (row) => {
    // Implement the edit action for the selected row
    openModal("edit", row);
  };

//   const handleView = (rowData) => {
//     console.log("Viewing meal plan:", rowData);
//     setSelectedMealPlan(rowData);  // Set selected meal plan with all its data (including weeklyPlan)
//     setViewModalOpen(true);  // Open the modal
//   };
 
  
// Handle page change
const handlePageChange = (page) => {
    setPage(page);
  };

  const handleDelete = (row) => {
    openModal("delete", row);
  };

  

  const handleStatus = (row) => {
    // Implement the status chnage for the selected row
    console.log("Delete clicked for row34:", row);
  };

  const handleActive = async (planId, active) => {
    setLoading(true);
     try {
    const res = await put(`/api/app/diet/toggleMealPlanActive/${planId}/active`, {
      active: active
    });

    console.log("Active status updated:", res.data);
    // Optionally update UI state
  } catch (err) {
    console.error("Failed to update active status:", err);
  }
    setLoading(false);
   
    const message = active
    ? `Status has been successfully activated.`
    : `Status has been successfully deactivated.`;
    setMessage(message);
    toastMessage(message, "success");
  };

  const handleSearch = (searchText) => {
   setSearch(searchText.trim());
    setPage(1);
  };

  const handleCloseDeleteModal = () => {
    setDeleteModalOpen(false);
  };

  const handleChange = (page) => {
    setPage(page);
  };

  const openModal = (type, dataForEdit) => {
    if (type === "add") {
      setIsModalOpen(true);
    } else if (type === "edit") {
      setEditModal(true);
      setSelectedMealPlan(dataForEdit);
    } else if (type === "delete") {
      setDeleteModalOpen(true);
      setDeleteUser(dataForEdit);
    }
  };

  const closeModal = (type) => {
    if (type === "add") {
      setIsModalOpen(false);
    } else if (type === "edit") {
      setEditModal(false);
      setEditData({});
    }
  };

  const handleDisplay = async (rowData) => {
    // Implement the edit action for the selected row
    
    try {
        // const res = await get(`/api/app/diet/meal-plan/${rowData._id}`);
        // console.log("Viewing meal plan:", res);
        setSelectedMealPlan(rowData);
        console.log("---------->><>>",selectedMealPlan.weeklyPlan);
        setViewModalOpen(true);
      } catch (error) {
        toastMessage("Failed to load meal plan details", "error");
      }
  };

  const refreshMealPlan = async () => {
    try {
      const response = await get(`/api/app/diet/mealPlanGetAdmin`);
      if (response?.success) {
        const updatedMealPlan = response.data.find(plan => plan._id === selectedMealPlan._id);
        if (updatedMealPlan) {
          setSelectedMealPlan(updatedMealPlan);
        }
      }
    } catch (error) {
      console.error("Error refreshing meal plan:", error);
    }
  };

  const handleSubmit = async (formData, isEditing, id) => {
    try {
      console.log("🍽️ FRONTEND: Meal Plan Creation Started");
      console.log("📝 Form Data:", JSON.stringify(formData, null, 2));
      console.log("🔄 Is Editing:", isEditing);
      console.log("🆔 ID:", id);

      setUploadLoading(true);

      // Prepare the request data
      const requestData = {
        dietType: formData.dietType || "traditional",
        answers: formData.answers || []
      };

      console.log("📤 Request Data to be sent:", JSON.stringify(requestData, null, 2));

      // Make the API call
      console.log("🌐 Making API call to /api/app/diet/mealPlan");
      const response = await post("/api/app/diet/mealPlan", requestData);

      console.log("📥 API Response received:", JSON.stringify(response, null, 2));

      if (response?.success) {
        console.log("✅ SUCCESS: Meal plan created successfully");
        console.log("📊 Response Details:", {
          mealPlanId: response.mealPlan?._id,
          dietResponseId: response.dietResponse?._id,
          message: response.message
        });

        toastMessage(response.message || "Meal plan created successfully!", "success");
        
        // Refresh the meal plans list
        console.log("🔄 Refreshing meal plans list...");
        await fetchMealPlans();
        
        // Close the modal
        closeModal(isEditing ? "edit" : "add");
        
        console.log("🎉 FRONTEND: Meal Plan Creation Process Completed Successfully");
      } else {
        console.log("❌ ERROR: Meal plan creation failed");
        console.log("❌ Error Response:", response);
        
        const errorMessage = response?.message || "Failed to create meal plan";
        console.log("❌ Error Message:", errorMessage);
        
        toastMessage(errorMessage, "error");
      }
    } catch (error) {
      console.log("❌ EXCEPTION: Error in meal plan creation");
      console.log("❌ Error Object:", error);
      console.log("❌ Error Message:", error.message);
      console.log("❌ Error Stack:", error.stack);
      
      const errorMessage = error?.message || "Failed to create meal plan";
      toastMessage(errorMessage, "error");
    } finally {
      console.log("🏁 FRONTEND: Meal Plan Creation Process Finished");
      setUploadLoading(false);
    }
  };

  // const handlePreview = (url) => {
  //   if (!url) return;
  //   setPreviewUrl(url);
  //   setPreviewModal(true);
  // };

  // const handleDownload = async (url) => {
  //   try {
  //     if (!url) {
  //       toastMessage("No file available for download", "error");
  //       return;
  //     }
  
  //     // Handle case where URL might be an array
  //     const downloadUrl = Array.isArray(url) ? url[0] : url;
  
  //     if (typeof downloadUrl !== "string" || !downloadUrl.startsWith("http")) {
  //       toastMessage("Invalid file URL", "error");
  //       return;
  //     }
  
  //     // Extract filename from URL or generate one
  //     const filename = downloadUrl.split('/').pop() || `download-${Date.now()}`;
      
  //     // Fetch the file first
  //     const response = await fetch(downloadUrl);
  //     const blob = await response.blob();
  //     const blobUrl = window.URL.createObjectURL(blob);
  
  //     // Create hidden anchor element
  //     const link = document.createElement('a');
  //     link.href = blobUrl;
  //     link.download = filename;
  //     link.style.display = 'none';
      
  //     // Append to body and trigger click
  //     document.body.appendChild(link);
  //     link.click();
      
  //     // Clean up
  //     setTimeout(() => {
  //       document.body.removeChild(link);
  //       window.URL.revokeObjectURL(blobUrl);
  //     }, 100);
  
  //   } catch (error) {
  //     console.error("Download failed:", error);
  //     toastMessage("Download failed. Please try again.", "error");
      
  //     // Fallback to normal download if fetch fails
  //     const fallbackLink = document.createElement('a');
  //     fallbackLink.href = url;
  //     fallbackLink.download = url.split('/').pop();
  //     document.body.appendChild(fallbackLink);
  //     fallbackLink.click();
  //     document.body.removeChild(fallbackLink);
  //   }
  // };
  const handleDeleteUser = async (row) => {
  try {
    const response = await deleteAPI(`/api/app/diet/diet-meal-plans/${row._id}`);
    toastMessage(response?.message || "Meal plan deleted successfully", "success");
    fetchMealPlans(""); // Refresh list after deletion
  } catch (error) {
    console.error("Delete failed:", error);
    toastMessage("Something went wrong while deleting", "error");
  }
  setDeleteModalOpen(false);
};

  // Manual trigger for meal plan generation
  const handleManualTrigger = async (userId, planId = null) => {
    // Reset function to clear loading state
    const resetLoading = () => {
      if (planId) {
        setGeneratingPlan(prev => {
          const newState = { ...prev };
          delete newState[planId];
          return newState;
        });
      }
    };

    try {
      console.log("🔍 [Diet Plan] Generating new plan for userId:", userId, "planId:", planId);
      
      if (!userId) {
        toastMessage("Patient ID is missing. Cannot generate meal plan.", "error");
        resetLoading();
        return;
      }
      
      // Set generating state for this specific plan
      if (planId) {
        setGeneratingPlan(prev => ({ ...prev, [planId]: true }));
      }
      
      // Show initial feedback
      toastMessage("Generating meal plan... This may take a few moments.", "info");
      
      const res = await post(`/api/app/diet/trigger-meal-plan-generation/${userId}`);
      
      console.log("🔍 [Diet Plan] Generate response:", res);
      console.log("🔍 [Diet Plan] Response type:", typeof res);
      console.log("🔍 [Diet Plan] Response keys:", Object.keys(res || {}));
      console.log("🔍 [Diet Plan] Response status:", res?.status);
      console.log("🔍 [Diet Plan] Response message:", res?.message);
      
      // POST wrapper: { data: serverBody, response: "Success" } or error object
      if (res?.response === "Failure") {
        console.error("❌ [Diet Plan] Generate API error:", res);
        let errorMsg = res?.message || res?.error || "Failed to generate meal plan";
        
        // Check if this is a 500 error about null patient/user
        if (res?.status === 500) {
          if (errorMsg.includes("Cannot read properties of null") || errorMsg.includes("reading '_id'")) {
            errorMsg = `Backend Error: The patient/user with ID "${userId}" was not found in the database.\n\nError: ${errorMsg}\n\nThis may happen if:\n- The patient was deleted\n- The patient ID is incorrect\n- The database connection failed\n\nPlease verify the patient ID and try again.`;
            console.error("❌ [Diet Plan] Patient lookup failed - Patient ID:", userId);
            console.error("❌ [Diet Plan] This is a backend issue - patient/user not found in database");
          } else {
            errorMsg = `Backend Error (500): ${errorMsg}\n\nPlease contact support if this issue persists.`;
          }
        }
        
        toastMessage(errorMsg, "error");
        resetLoading();
        return;
      }
      
      const serverResponse = res?.data || res;
      console.log("🔍 [Diet Plan] Server response:", serverResponse);
      
      if (serverResponse?.success === false) {
        let errorMsg = serverResponse?.message || serverResponse?.error || "Failed to generate meal plan";
        
        // Check if this is a backend error about null patient
        if (errorMsg.includes("Cannot read properties of null") || errorMsg.includes("reading '_id'")) {
          errorMsg = `Backend Error: The patient/user with ID "${userId}" was not found in the database.\n\nError: ${errorMsg}\n\nThis may happen if:\n- The patient was deleted\n- The patient ID is incorrect\n- The database connection failed\n\nPlease verify the patient ID and try again.`;
          console.error("❌ [Diet Plan] Patient lookup failed - Patient ID:", userId);
        }
        
        toastMessage(errorMsg, "error");
        resetLoading();
        return;
      }
      
      // Success case
      const successMsg = serverResponse?.message || "New meal plan generated successfully!";
      toastMessage(successMsg, "success");
      
      // Reset loading state on success
      resetLoading();
      
      // Refresh the list after a short delay to allow backend to process
      setTimeout(() => {
        fetchMealPlans(search || "");
      }, 1000);
      
    } catch (error) {
      console.error("❌ [Diet Plan] Error triggering meal plan generation:", error);
      console.error("❌ [Diet Plan] Error details:", {
        message: error?.message,
        response: error?.response,
        status: error?.response?.status,
        data: error?.response?.data,
        isAxiosError: error?.isAxiosError
      });
      
      let errorMsg = "Failed to generate meal plan";
      
      // Handle axios errors (500, 404, etc.)
      if (error?.response?.data?.message) {
        errorMsg = error.response.data.message;
      } else if (error?.response?.data?.error) {
        errorMsg = error.response.data.error;
      } else if (error?.message) {
        errorMsg = error.message;
      }
      
      // Special handling for 500 errors (backend issues)
      if (error?.response?.status === 500) {
        const backendMsg = error?.response?.data?.message || errorMsg;
        errorMsg = `Backend error: ${backendMsg}\n\nThe patient/user with ID "${userId}" may not exist or was deleted. Please verify the patient ID is correct.`;
        console.error("❌ [Diet Plan] Backend 500 error - Patient ID may be invalid:", userId);
      } else if (error?.response?.status === 404) {
        errorMsg = `Patient not found. The patient ID "${userId}" does not exist in the system.`;
      } else if (error?.response?.status === 408 || error?.code === "ECONNABORTED") {
        errorMsg = "Request timed out. The meal plan generation may still be processing. Please check back in a few moments.";
      }
      
      toastMessage(errorMsg, "error");
      resetLoading();
    }
  };

  // Check meal plan status
  const handleCheckStatus = async (userId) => {
    try {
      console.log("🔍 [Diet Plan] Checking status for userId:", userId);
      
      if (!userId) {
        toastMessage("Patient ID is missing. Cannot check meal plan status.", "error");
        return;
      }
      
      const res = await get(`/api/app/diet/meal-plan-status/${userId}`);
      
      console.log("🔍 [Diet Plan] Status response:", res);
      
      // Check if response is an error object
      if (res?.response === "Failure") {
        console.error("❌ [Diet Plan] Status API error:", res);
        toastMessage(res?.message || "Failed to check meal plan status", "error");
        return;
      }
      
      // GET returns response.data directly
      const serverResponse = res?.data || res;
      
      if (serverResponse?.success === false) {
        toastMessage(serverResponse?.message || "Failed to check meal plan status", "error");
        return;
      }
      
      if (serverResponse?.success) {
        const { isCompleted, planDates, canGenerateNew } = serverResponse;
        
        if (isCompleted) {
          toastMessage("Meal plan is completed and ready for new generation", "info");
        } else {
          const remainingDays = planDates?.filter(date => !date.isPast).length || 0;
          toastMessage(`Meal plan is still active. ${remainingDays} days remaining.`, "info");
        }
      } else {
        // Handle case where response doesn't have success flag
        toastMessage("Unable to determine meal plan status", "warning");
      }
    } catch (error) {
      console.error("❌ [Diet Plan] Error checking meal plan status:", error);
      const errorMsg = error?.response?.data?.message || error?.response?.data?.error || error?.message || "Failed to check meal plan status";
      toastMessage(errorMsg, "error");
    }
  };

  return (
    <>
      <Layout>
        <div style={{ padding: "1rem" }}>
          <Typography variant="h5">Diet Meal Plan</Typography>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div style={{ width: "40%" }}>
              <Searchbar
                search={handleSearch}
                placeholder={"Search by Patient Name"}
                debounceTime={1000}
              />
            </div>

            {/* <Button
              onClick={() => openModal("add")}
              variant="outlined"
              startIcon={<AddIcon fontSize="large" />}
              style={{ fontWeight: "bold" }}
            >
              add new diet content
            </Button> */}
          </div>
          
          {/* Diet Type and Phase Filters */}
          <Box sx={{ 
            display: "flex", 
            gap: 2, 
            mb: 2, 
            mt: 2,
            flexWrap: "wrap",
            alignItems: "center"
          }}>
            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel>Diet Type</InputLabel>
              <Select
                value={dietTypeFilter}
                label="Diet Type"
                onChange={handleDietTypeFilterChange}
                size="small"
              >
                {dietTypeOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            
            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel>Phase</InputLabel>
              <Select
                value={phaseFilter}
                label="Phase"
                onChange={handlePhaseFilterChange}
                size="small"
                disabled={dietTypeFilter !== "low_fodmap"}
              >
                {phaseOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel>Current Week</InputLabel>
              <Select
                value={weekFilter}
                label="Current Week"
                onChange={handleWeekFilterChange}
                size="small"
              >
                <MenuItem value="all">All Weeks</MenuItem>
                {Array.from({ length: 12 }, (_, i) => i + 1).map((week) => (
                  <MenuItem key={week} value={week}>
                    Week {week}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            
            {/* Filter Summary */}
            <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
              <Typography variant="body2" color="text.secondary">
                Showing:
              </Typography>
              {dietTypeFilter !== "all" && (
                <Chip
                  label={dietTypeOptions.find(opt => opt.value === dietTypeFilter)?.label}
                  color="primary"
                  size="small"
                  onDelete={() => setDietTypeFilter("all")}
                />
              )}
              {phaseFilter !== "all" && dietTypeFilter === "low_fodmap" && (
                <Chip
                  label={phaseOptions.find(opt => opt.value === phaseFilter)?.label}
                  color="secondary"
                  size="small"
                  onDelete={() => setPhaseFilter("all")}
                />
              )}
              {weekFilter !== "all" && (
                <Chip
                  label={`Week ${weekFilter}`}
                  color="info"
                  size="small"
                  onDelete={() => setWeekFilter("all")}
                />
              )}
            </Box>
            
            {/* Reset Button */}
            {(dietTypeFilter !== "all" || phaseFilter !== "all" || weekFilter !== "all") && (
              <Button
                variant="outlined"
                size="small"
                onClick={resetFilters}
                sx={{ ml: 2 }}
              >
                Reset Filters
              </Button>
            )}
          </Box>
          
          {/* Diet Type Summary */}
          <Box sx={{ 
            display: "flex", 
            gap: 2, 
            mb: 2,
            flexWrap: "wrap",
            alignItems: "center"
          }}>
            <Typography variant="body2" color="text.secondary">
              Summary:
            </Typography>
            <Chip
              label={`Traditional: ${mealPlans.filter(plan => plan.dietType === "traditional").length}`}
              color="primary"
              size="small"
              variant="outlined"
            />
            <Chip
              label={`Low FODMAP: ${mealPlans.filter(plan => plan.dietType === "low_fodmap").length}`}
              color="secondary"
              size="small"
              variant="outlined"
            />
            <Chip
              label={`Total: ${mealPlans.length}`}
              color="default"
              size="small"
              variant="outlined"
            />
            <Chip
              label={`Week 1-4: ${mealPlans.filter(plan => {
                const week = plan.dietInfo?.currentWeek || plan.dietInfo?.lowFodmap?.currentWeek;
                return week >= 1 && week <= 4;
              }).length}`}
              color="success"
              size="small"
              variant="outlined"
            />
            <Chip
              label={`Week 5-8: ${mealPlans.filter(plan => {
                const week = plan.dietInfo?.currentWeek || plan.dietInfo?.lowFodmap?.currentWeek;
                return week >= 5 && week <= 8;
              }).length}`}
              color="warning"
              size="small"
              variant="outlined"
            />
            <Chip
              label={`Week 9-12: ${mealPlans.filter(plan => {
                const week = plan.dietInfo?.currentWeek || plan.dietInfo?.lowFodmap?.currentWeek;
                return week >= 9 && week <= 12;
              }).length}`}
              color="error"
              size="small"
              variant="outlined"
            />
          </Box>
          
          <CustomTable
        data={getFilteredMealPlans()}
        columns={DietMealPlanTableColumns}  // Pass handleView here
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        handleStatus={handleStatus}
        handleDisplay={handleDisplay}
        handleActive={(row, active) => handleActive(row, active)}
        handlePageChange={handlePageChange}
        handleCheckStatus={handleCheckStatus}
        handleManualTrigger={handleManualTrigger}
        generatingPlan={generatingPlan}
        pageNumber={page}
        pageCount={pageCount}
        totalData={totalData}
        perPage={perPage}
        currentPage={currentPage}
        loading={loading}
        customRender={{
          "currentWeek": (value) => (
            <Chip
              label={`Week ${value}`}
              color="info"
              size="small"
              variant="outlined"
            />
          ),
        }}
      />
      <FormModal
              accept=".pdf,video/*,image/*"
              loading={uploadLoading}
              setSelectedCategory={setSelectedCategory}
              isOpen={isModalOpen}
              onClose={() => closeModal(editModal ? "edit" : "add")}
              onSubmit={handleSubmit}
              fields={blogContentFormFields}
              header={editModal ? "Edit Diet Video" : "Add Diet Video"}
              initialData={editData}
              isEditing={editModal}
            />
      {/* Modal to display weekly plan */}
      <Dialog
            open={viewModalOpen}
            onClose={() => setViewModalOpen(false)}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>Meal Plan for {selectedMealPlan.patientName}</DialogTitle>
            <DialogContent dividers>
  <Typography variant="body2" gutterBottom>
    Created Date: {new Date(selectedMealPlan.createdAt).toLocaleDateString()} | Updated Date: {new Date(selectedMealPlan.updatedAt).toLocaleDateString()}
  </Typography>
  {/* <Typography variant="body2" gutterBottom>
    Total Weeks: {selectedMealPlan.totalWeeks} | Total Meals: {selectedMealPlan.totalMeals}
  </Typography> */}
  <Typography variant="body2" gutterBottom>
    Meal Per Day: {selectedMealPlan.mealTypes?.join(', ')}
  </Typography>
  <Divider sx={{ my: 2 }} />

  {selectedMealPlan.weeklyPlan?.map((dayPlan, idx) => (
  <div key={idx} style={{ marginBottom: "2rem" }}>
    <Typography variant="h6" gutterBottom>
      {dayPlan.day?.charAt(0).toUpperCase() + dayPlan.day?.slice(1) || 'Unknown Day'} | {dayPlan.date ? new Date(dayPlan.date).toLocaleDateString() : 'No Date'}
    </Typography>

    <Paper variant="outlined" sx={{ overflowX: "auto" }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Meal Type</TableCell>
            <TableCell>Food</TableCell>
            <TableCell>Quantity</TableCell>
            {/* <TableCell>Nutrition</TableCell> */}
            <TableCell>Calories</TableCell>
            <TableCell>Protein(g)</TableCell>
            <TableCell>Carbs(g)</TableCell>
            <TableCell>Fiber</TableCell>
            <TableCell>Fat </TableCell>
            <TableCell>Fod-Map </TableCell>
            {/* <TableCell>Recipe</TableCell>
            <TableCell>Alternatives</TableCell> */}
          </TableRow>
        </TableHead>
        <TableBody>
          {dayPlan.meals?.map((meal, mealIdx) =>
            meal.foods?.map((food, foodIdx) => (
              <TableRow key={`${mealIdx}-${foodIdx}`}>
                <TableCell>{meal.type.toUpperCase()}</TableCell>
                <TableCell>{food.name}</TableCell>
                <TableCell>
                  {food.quantity?.value} {food.quantity?.unit}
                </TableCell>
                <TableCell>{food.nutrition?.calories || "-"}</TableCell>
                <TableCell>{food.nutrition?.protein || "-"}</TableCell>
                <TableCell>{food.nutrition?.carbs || "-"}</TableCell>
                <TableCell>{food.nutrition?.fiber || "-"}</TableCell>
                <TableCell>{food.nutrition?.fat || "-"}</TableCell>
                <TableCell>{food.fod_map?.value || "-"}</TableCell>
                {/* <TableCell>
                  {food.recipe?.ingredients?.map((ingredient, i) => (
                    <div key={i}>
                      {ingredient.item} - {ingredient.quantity} {ingredient.unit}
                    </div>
                  ))}
                  <div>
                    <strong>Steps:</strong>{" "}
                    {food.recipe?.preparationSteps?.join(" ")}
                  </div>
                </TableCell>
                <TableCell>
                  {food.alternatives?.length > 0 ? (
                    food.alternatives.map((alt, i) => (
                      <div key={i}>
                        <strong>{alt.name}</strong> (
                        {alt.quantity?.value} {alt.quantity?.unit}) -{" "}
                        {alt.nutrition?.calories} kcal
                      </div>
                    ))
                  ) : (
                    "N/A"
                  )}
                </TableCell> */}
              </TableRow>
            ))
          )}
        </TableBody>
      </Table>
    </Paper>
    
    <Divider sx={{ my: 3 }} />
  </div>
))}
</DialogContent>
      </Dialog>
      <Dialog
            open={editModal}
            onClose={() => setEditModal(false)}
            maxWidth="md"
            fullWidth
          >
            <DialogTitle>Meal Plan for {selectedMealPlan.patientName}</DialogTitle>
            <DialogContent dividers>
            {selectedMealPlan.weeklyPlan?.map((dayPlan, idx) => (
  <div key={idx} style={{ marginBottom: "2rem" }}>
    <Typography variant="h6" gutterBottom>
      {dayPlan.day?.charAt(0).toUpperCase() + dayPlan.day?.slice(1) || 'Unknown Day'} | {dayPlan.date ? new Date(dayPlan.date).toLocaleDateString() : 'No Date'}
    </Typography>
    <EditableMealPlanTable
      dayPlan={dayPlan}
      planId={selectedMealPlan._id}
      onUpdate={async (updatedDayPlan) => {
        console.log('Received updated day plan:', updatedDayPlan);
        const updatedWeekly = [...selectedMealPlan.weeklyPlan];
        updatedWeekly[idx] = updatedDayPlan;
        console.log('Updated weekly plan:', updatedWeekly);
        setSelectedMealPlan({ ...selectedMealPlan, weeklyPlan: updatedWeekly });
        
        // Refresh the meal plan data from server
        await refreshMealPlan();
      }}
    />
   </div>
))}
    </DialogContent>
            </Dialog>

            <Dialog open={isDeleteModalOpen} onClose={handleCloseDeleteModal}>
  <DialogTitle>Confirm Delete</DialogTitle>
  <DialogContent>
    <Typography>
      Are you sure you want to delete meal plan for{" "}
      <strong>{deleteUser?.patientName}</strong>?
    </Typography>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseDeleteModal}>Cancel</Button>
    <Button onClick={() => handleDeleteUser(deleteUser)} color="error">
      Delete
    </Button>
  </DialogActions>
</Dialog>

        </div>
      </Layout>
      
    </>
  );
};

export default DietMealPlan;
